<div class="row justify-content-center" id="frmReqNewDoc">
  <div class="col-9 mt-5 mb-5 container" [formGroup]="form">
    <div class="row mt-3">
      <div class="col-md-12 text-center">
        <h4 class="text-cust-blue" translate>ขอเอกสารใหม่</h4>
      </div>
    </div>

    <div class="row mt-3" *ngIf="isCompany">
      <div class="col-2 text-right">
        <label class="required" translate>CompanyName</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="dpa_companyname" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_companyname.value == null || formControl.dpa_companyname.value.trim().length == 0) && formControl.dpa_companyname.errors?.required">
          <label translate>Please specify</label> <label translate>CompanyName</label>
          <!-- กรุณาระบุ ชื่อนิติบุคคล -->
        </span>
      </div>
      <!--    <div class="col-3 text-right">
        <label class="" translate>Regis Tax no.</label><label>/</label>
        <label class="" translate>RegisCompanyId</label>
      </div>
      <div class="col-3" *ngIf="contact == null || contact.dpa_passport == null || contact.dpa_passport.trim() == ''">
        <input type="text" class="form-control" formControlName="dpa_registrationid" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_registrationid.value == null || formControl.dpa_registrationid.value.trim().length == 0) && formControl.dpa_registrationid.errors?.required">
          <label translate>Please specify</label> <label class="" translate>Regis Tax no.</label><label>/</label>
          <label class="" translate>RegisCompanyId</label>
        </span>
      </div>
    </div> 

    <div class="row mt-3" *ngIf="isCompany">
      <div class="col-3 text-right">
        <label class="required" translate>Account no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" maxlength="13" formControlName="dpa_accountno" (keypress)="numberOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_accountno.value == null || formControl.dpa_accountno.value.trim().length == 0) && formControl.dpa_accountno.errors?.required">
          <label translate>Please specify</label> <label translate>Account no.</label>
        </span>
      </div>
      <div class="col-3 text-right">
        <label class="required" translate>RegisterE-mail</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="emailaddress1" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.emailaddress1.value ==null || formControl.emailaddress1.value.trim().length == 0)">
          <label translate>Please specify</label> <label translate>RegisterE-mail</label>
        </span>
        <span class="text-danger"
          *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
          <label translate>emailInvalid</label>
        </span>
      </div> -->
    </div>

    <div class="row mt-3">
      <div class="col-2 text-right">
        <label class="required" *ngIf="!isCompany" translate>Name</label>
        <label class="required" *ngIf="isCompany" translate>Attorney-in-fact's name</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="firstname" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.firstname.value == null || formControl.firstname.value.trim().length == 0) && formControl.firstname.errors?.required">
          <label translate>Please specify</label> <label translate>Name</label>
          <!-- กรุณาระบุ ชื่อ -->
        </span>
      </div>
      <div class="col-3 text-right">
        <label class="required" *ngIf="!isCompany" translate>Surname</label>
        <label class="required" *ngIf="isCompany" translate>Attorney-in-fact's surname</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="lastname" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.lastname.value == null || formControl.lastname.value.trim().length == 0) && formControl.lastname.errors?.required">
          <label translate>Please specify</label> <label translate>Surname</label>
          <!-- กรุณาระบุ นามสกุล -->
        </span>
      </div>
    </div>

    <!--  <div class="row mt-3" *ngIf="!isCompany">
      <div class="col-3 text-right">
        <label class="" translate>Date of Birth</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th" id="dob">
      </div>
      <div class="col-3 text-right">
        <label class="" translate *ngIf="!isForeign">ID no.</label><label *ngIf="!isForeign">/</label>
        <label class="required" translate *ngIf="!isForeign">Regis Tax no.</label>
        <label class="" translate *ngIf="isForeign">Passport no.</label>
      </div>
      <div class="col-3" *ngIf="!isForeign">
        <input type="text" class="form-control" formControlName="dpa_idcard" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_idcard.value == null || formControl.dpa_idcard.value.trim().length == 0) && formControl.dpa_idcard.errors?.required">
          <label translate>Please specify</label> <label translate>ID no.</label>/<label translate>Regis Tax no.</label>
        </span>
      </div>
      <div class="col-3" *ngIf="isForeign">
        <input type="text" class="form-control" formControlName="dpa_passport" readonly>
      </div>
    </div> -->

    <div class="row mt-3" *ngIf="isCompany">
      <!--  <div class="col-3 text-right">
        <label class="" translate>ID no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="dpa_authorizedperson_idcard">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_authorizedperson_idcard.value == null || formControl.dpa_authorizedperson_idcard.value.trim().length == 0) && formControl.dpa_authorizedperson_idcard.errors?.required">
          <label translate>Please specify</label> <label translate>ID no.</label>
        </span>
      </div> -->
      <div class="col-2 text-right">
        <label class="required" translate>Regis Phone no.</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="dpa_authorizedperson_telephone"
          (keypress)="telephoneOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_authorizedperson_telephone.value == null || formControl.dpa_authorizedperson_telephone.value.trim().length == 0) && formControl.dpa_authorizedperson_telephone.errors?.required">
          <label translate>Please specify</label> <label translate>Regis Phone no.</label>
        </span>
      </div>
    </div>

    <div class="row mt-3" *ngIf="!isCompany">
      <!-- <div class="col-3 text-right">
        <label class="required" translate>Account no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" maxlength="13" formControlName="dpa_accountno" (keypress)="numberOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_accountno.value == null || formControl.dpa_accountno.value.trim().length == 0) && formControl.dpa_accountno.errors?.required">
          <label translate>Please specify</label> <label translate>Account no.</label>
        </span>
      </div> -->

      <div class="col-6 col-sm-2 text-right">
        <label class="required" translate>Regis Phone no.</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="telephone1" (keypress)="telephoneOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.telephone1.value == null || formControl.telephone1.value.trim().length == 0) && formControl.telephone1.errors?.required">
          <label translate>Please specify</label> <label translate>Regis Phone no.</label>
        </span>
      </div>

      <div class="col-6 col-sm-3 text-right">
        <label class="required" translate>RegisterE-mail</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="emailaddress1" >
        <span class="text-danger"
          *ngIf="submitted && (formControl.emailaddress1.value == null || formControl.emailaddress1.value.trim().length == 0)">
          <label translate>Please specify</label> <label translate>RegisterE-mail</label>
        </span>
        <span class="text-danger"
          *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
          <label translate>emailInvalid</label>
        </span>
      </div>
    </div>



    <div class="row mt-3">
      <div class="col-3 col-sm-2 text-right">
        <label class="required" translate>Address</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_homeno">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_contact_homeno.value == null || formControl.dpa_contact_homeno.value.trim().length == 0) && formControl.dpa_contact_homeno.errors?.required">
          <label translate>Please specify</label> <label translate>Address</label>
          <!-- กรุณาระบุ ที่อยู่ -->
        </span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-2 text-right">
        <label class="" translate>Moo</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_moo" maxlength="100">
      </div>
      <div class="col-3 text-right">
        <label class="" translate>Street</label>
      </div>
      <div class="col-lg-3 col-sm-4 col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_street">
      </div>
    </div>

    <div class="row mt-3 select2-th">
      <div class="col-md-2 text-right">
        <label translate>Select Location</label>
      </div>
      <div class="col-md-9">
        <select class="form-control select2 select2th">
          <option value="" translate>Select</option>
          <option *ngFor="let sd of combinedAddressList" [value]="sd.id">
            {{sd.text}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-3 select2-en">
      <div class="col-md-3 text-right">
        <label translate>Select Location</label>
      </div>
      <div class="col-md-9">
        <select class="form-control select2 select2en">
          <option value="" translate>Select</option>
          <option *ngFor="let sd of combinedAddressListEn" [value]="sd.id">
            {{sd.text_eng}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-2 text-right">
        <label translate>Sub-district</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_subdistictname" readonly>
      </div>
      <div class="col-md-3 text-right">
        <label translate>District</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_distictname" readonly>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-2 text-right">
        <label translate>Province</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_provincname" readonly>
      </div>
      <div class="col-md-3 text-right">
        <label translate>Postal code</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_postcodename" readonly>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-2 text-right">
        <label translate>Country</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_countryname" readonly>
      </div>
    </div>

    <hr>

    <!-- table -->
    <div class="card-body table-responsive table">
      <table style="width:100%" class="table table-bordered table-hover result-table">
        <thead>
          <tr class="tbheader">
            <th class="checkbox-col">
              <input type="checkbox" id="chkboxAll">
            </th>
            <th>เลขที่คำขอ</th>
            <th>ประเภทคำขอ</th> 
            <th>สถานะ</th>
            <th class="colhidden"></th>
            <th class="colhidden"></th>
          </tr>
        </thead>
        <tbody id="tbcrm03">
          <tr *ngFor="let c of crm03Obj; let i = index">
            <td class="checkbox-col">
              <input type="checkbox" class="row-checker" value="{{c.RequestedNo}}" name="chkReqNo"
                (change)="onCheckChange()" *ngIf="c.isPrint != 1">
            </td>
            <td *ngIf="c.isPrint == 1">
              <a id="{{c.RequestedNo}}" style="color: #007bff;cursor: pointer;" (click)="goToClick($event)">{{c.RequestedNo}}</a>
            </td>
            <td *ngIf="c.isPrint != 1">{{c.RequestedNo}}</td>
            <td>{{c.RequestType}}</td> 
            <td>{{c.isPrintMessage}}</td>
            <td class="colhidden">{{c.UID}}</td>
            <th class="colhidden">{{c.isPrint}}</th>
          </tr>
        </tbody>
      </table>
      <div id="divNoData" class="row table-bordered bordernodata colhidden">
        <div class="col-md-12 text-center">
          <label translate>ไม่พบข้อมูล</label>
        </div>
      </div>
    </div>





    <div class="row mt-4 mb-4">
      <div class="col-12 text-center">
        <!--  <button class="btn btn-default mr-2" (click)="save()" translate>Save</button>-->
        <button class="btn btn-default mr-2" id="savedata"   (click)="CheckFormAndOTP()" [disabled]="disablebtnSave"
          translate>Save</button>
        <button class="btn btn-default ml-2" (click)="close()" translate>Close</button>
      </div>
    </div>

  </div>
</div>




<!-- OTP -->
<div class="mt-5 mb-3 border" *ngIf="showOtp">
  <div class="row text-center">
    <div class="col-12 col-sm-10 col-md-12">
      <div class="container">
        <div class="row mt-4 mb-4">
          <div class="col-12 text-center">
            <h4 class="text-cust-blue" translate>SMS-OTP</h4>
          </div>
        </div>
        <div class="row mt-4 mb-4">
          <div class="col-12 text-center">
            <p translate>The SMS-OTP will sent to your registered mobile number.</p>
            <p>
              <label id="PhoneNo" style="color: red; font-size: 1.5rem;">{{telephoneOtp}}</label>
            </p>
            <p class="sr-only">กรุณาตรวจสอบ</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <label style="font-size: 1.1rem;">Reference Code: &nbsp;</label>
            <label style="color: red; font-size: 1.5rem;">{{otpRef}}</label>
          </div>
        </div>
        <div class="row m-2">
          <div class="col-12 text-center">
            <label style="font-size: 1.25rem;" translate>Please input your SMS-OTP password.</label>
          </div>
        </div>
        <div class="row m-2 justify-content-center">
          <div class="col-3">
            <button type="button" class="btn btn-default w-100" [disabled]="disableResentOtp"
              (click)="requestOtp()">{{requestOtpLbl}} {{otpTimer == 0 ? "" : otpTimer}}</button>
          </div>
        </div>
        <div class="row m-2 justify-content-center">
          <div id="divOtp" class="col-3 text-center colhidden">
            <input type="password" [(ngModel)]="otp" class="form-control" style="font-size: 1.1rem; text-align: center;"
              placeholder="{{'SMS-OTP' | translate}}">
          </div>
        </div>
        <div class="row mt-4 mb-4 justify-content-center">
          <div class="col-6 text-center">
            <!--  <button type="button" class="btn btn-default mr-2" [disabled]="otp.trim().length == 0"
                          (click)="SubmitOTP()"><label translate>SendOTP</label>{{OTPCountDown}}</button>
                      <button type="button" class="btn btn-default ml-2" (click)="cancelOtp()" translate>CancelOTP</button>
                      -->
            <button type="button" class="btn btn-default mr-2" [disabled]="otp.trim().length == 0"
              (click)="SubmitOTP()"><label translate>SendOTP</label>{{OTPCountDown}}</button>
            <button type="button" class="btn btn-default ml-2" (click)="cancelOtp()" translate>CancelOTP</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End OTP -->


<!-- status request document -->

<div class="row justify-content-center hideDiv" id="frmStatusReqNewDoc">
  <div class="col-9 mt-5 mb-5 container">
    <div class="row mt-3">
      <div class="col-md-12 text-center">
        <h4 class="text-cust-blue" translate>เอกสารที่ต้องการ</h4>
      </div>
    </div>


    <!-- table -->
    <div class="card-body table-responsive table">
      <table style="width:100%" class="table table-bordered table-hover result-table">
        <thead>
          <tr class="tbheader">
            <!--  <th class="checkbox-col">
              <input type="checkbox" id="chkboxAll">
            </th> -->
            <th>วันที่ทำรายการ</th>
            <th>เลขที่คำขอ</th>
            <th>สถานะคำขอ</th>
            <th></th>
          </tr>
        </thead>
        <tbody id="tbcrm08DROS">
          <tr *ngFor="let c of crm08DROSList; let i = index">
            <!-- <td class="checkbox-col">
              <input type="checkbox" class="row-checker" value="{{c.RequestedNo}}" name="chkReqNo"
                (change)="onCheckChange()">
            </td>-->
            <td>{{c.CreateOn}}</td>
            <td>{{c.DROSRequestNo}}</td>
            <td>{{c.ProcessStatus}}</td>
            <td> <button class="btn btn-default btn-detail" (click)="ShowDetail(c.DROSRequestNo)" translate>รายละเอียด</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="row mt-3 mb-3 hideDiv" id="divDetail">
  <div class="col-12">
    <div class="row">
      <div class="col-12 text-center">
        <h4 class="text-cust-blue" translate>บุคคลธรรมดา/นิติบุคคล/ต่างชาติ/อื่นๆ</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 mx-auto container container2">
       <!-- <div class="row rowmargin">
          <div class="text-cust-blue col" translate>Name</div>
          <div class="col-md-4 divlbl">
            <label id="lblName">ทวีศักดิ์</label>
          </div>
          <div class="col-md-1 text-cust-blue" translate>Surname</div>
          <div class="col-md-6 divlbl">
            <label id="lblSurname">อุปะละ</label>
          </div>
        </div>-->
        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>ชื่อ-นามสกุล</div>
          <div class="col-md-10 divlbl">
            <label id="lblFullname">555 666</label>
          </div>
        </div>
        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>หมายเลขโทรศัพท์</div>
          <div class="col-md-10 divlbl">
            <label id="lblPhoneNo">0888888888</label>
          </div>
        </div>
        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>ที่อยู่จัดส่ง</div>
          <div class="col-md-10 divlbl">
            <!--  <input type="text" class="form-control form-control-2" id="txtIDNo">  -->
            <label id="lblAddress">300 กดเกดเ กดเกดเกด</label>
          </div>
        </div>

        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>หมายเลขคำร้อง</div>
          <div class="col-md-10 divlbl">
            <!-- <input type="text" class="form-control form-control-2" maxlength="13" id="txtAccNo"> -->
            <label id="lblDROSReqNo">123456789014441</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Progress -->
    <div id="divProgress">
      <div class="row mt-4 text-center">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <ul id="progressbarimg" class="progressbar-img content-center"> 
              <!--<li class="active step0"><img id="imgStatus01" width="101" style="background-color: white;" src="../../assets/images/icon_inprogress1.png"><br><span style="color: black;">ได้รับคำขอ</span>  </li> 
              <li class="active step0"><img id="imgStatus02" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress2.png"><br><span style="color: black;">อยู่ระหว่างจัดทำเอกสาร</span>   </li> 
              <li class="active step0"><img id="imgStatus03" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress3.png"><br><span style="color: black;">ดำเนินการจัดส่งเอกสาร</span>   </li>  -->
          </ul>
        </div>
        <div class="col-md-2"></div>
        <!--<div class="col-sm-2 col-md-3 col-lg-4 col-xl-5">

        </div>
        <div class="col-6 col-md-6">
         
           <ul id="progress" > 
            <li><img id="imgStatus01" width="101" style="background-color: white;" src="../../assets/images/icon_inprogress1.png"><label style="padding-left:64px;padding-bottom:10px">ได้รับคำขอ</label> </li> 
            <li><div class="blue" style="width: 6px;height: 35px;margin-left:45px"></div></li>
            <li><img id="imgStatus02" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress2.png"><label style="padding-left:64px;padding-bottom:10px">อยู่ระหว่างจัดทำเอกสาร</label></li> 
            <li><div class=" blue" style="width: 6px;height: 35px;margin-left:45px"></div></li>
            <li><img id="imgStatus03" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress3.png"><label style="padding-left:64px;padding-bottom:10px">ดำเนินการจัดส่งเอกสาร</label></li> 
          </ul>
        </div>--> 
    </div>
    <!-- End Progress -->

    <div class="row mt-5 mb-5">
      <div class="col-12 text-center">
        <button class="btn btn-default mr-2" (click)="BackToList()" translate>Back</button>
      </div>
    </div>
  </div>
  </div>
</div>
<!-- end status request document -->


// WEBPACK FOOTER //
// ./src/app/request-document/request-document.component.html